import React from "react";
import behanceFotter from "../Assets/behance_fotter.png";
import githubFotter from "../Assets/github_fotter.png";
import linkedinFotter from "../Assets/linkedin_fotter.png";
import './Fotter.css';


export const Fotter = () => {
  return (
    <div className="flex-fotter">
      <div className="icons">
      <a className="fotter-icon" href='https://www.behance.net/susanagarcia37' ><img className="fotter-icons" src={behanceFotter} alt="icon" /></a>
      <a className="fotter-icon" href='https://github.com/SusanaLab' ><img className="fotter-icons" src={githubFotter} alt="icon" /></a>
     <a  className="fotter-icon" href='https://www.linkedin.com/in/susana-front-end-uiux/ ' ><img   src={linkedinFotter} alt="icon" /></a> 
     </div> <p id="by-susana"> By Susana García </p>
    </div>
  );
};
